import { CodeNameModel } from 'components/common/types';
import {
  DirectSalesFilteredCampaignsStatusTableResponse,
  DirectSalesStatusOption,
} from 'components/common/types/DirectSalesCampaign.types';
import { DirectSalesStatusLabel } from 'components/pages/Planner/PlannerLineActions/DirectSalesPlannerLineActions/Status/StatusPanel/StatusPanel.types';

export const DIRECT_SALES_CAMPAIGN_PAGE_FILTERS_KEY = 'insights/direct-sales';

export const CAMPAIGN_STATUSES: {
  code: DirectSalesFilteredCampaignsStatusTableResponse;
  name: DirectSalesStatusLabel;
}[] = [
  { code: 'DRAFT', name: DirectSalesStatusLabel.DRAFT },
  { code: DirectSalesStatusOption.MIXED, name: DirectSalesStatusLabel.MIXED },
  { code: DirectSalesStatusOption.PROPOSAL, name: DirectSalesStatusLabel.PROPOSAL },
  { code: DirectSalesStatusOption.OPTION, name: DirectSalesStatusLabel.OPTION },
  { code: DirectSalesStatusOption.CONFIRMED, name: DirectSalesStatusLabel.CONFIRMED },
  { code: DirectSalesStatusOption.LIVE, name: DirectSalesStatusLabel.LIVE },
  { code: DirectSalesStatusOption.CANCELLED, name: DirectSalesStatusLabel.CANCELLED },
  { code: DirectSalesStatusOption.ENDED, name: DirectSalesStatusLabel.ENDED },
];

export const CAMPAIGN_MEDIA_TYPES: CodeNameModel[] = [
  { code: 'DIGITAL', name: 'Digital' },
  { code: 'PAPER', name: 'Paper' },
  { code: 'DIGITAL_AND_PAPER', name: 'Digital & Paper' },
];
